"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var layout_1 = require("../../layout");
var Text_1 = __importDefault(require("../../Text"));
var FeaturedIcon_1 = __importDefault(require("../FeaturedIcon"));
var CloseButton_1 = __importDefault(require("../../buttons/CloseButton"));
var TitleText = function (_a) {
    var v6 = _a.v6, children = _a.children;
    return v6 ? (react_1.jsx(Text_1.default, { weight: 600, size: 18, color: "var(" + style_1.TextColor.HEAD + ")" }, children)) : (react_1.jsx(Text_1.default.Body, { size: "xl", weight: "semibold", color: style_1.DesignSystemThemeColor.Gray.DARK_4, css: { overflow: 'hidden', textOverflow: 'ellipsis' } }, children));
};
var SubTitleText = function (_a) {
    var v6 = _a.v6, children = _a.children;
    return v6 ? (react_1.jsx(Text_1.default.Body, { color: "var(" + style_1.TextColor.DEFAULT + ")" }, children)) : (react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.DEFAULT, css: { overflow: 'hidden', textOverflow: 'ellipsis' } }, children));
};
var Paddings = {
    X: 24,
    Y: 16,
};
var DrawerHeader = function (_a) {
    var icon = _a.icon, title = _a.title, subtitle = _a.subtitle, onRequestClose = _a.onRequestClose, v6 = _a.v6;
    return (react_1.jsx(layout_1.Flex, { gap: v6 ? 8 : 16, css: {
            padding: Paddings.Y + "px " + Paddings.X + "px",
            position: 'relative',
            borderBottom: v6 ? "1px solid var(" + style_1.BorderColor.GRAY_LIGHT_3 + ")" : undefined,
        } },
        icon ? (react_1.jsx(FeaturedIcon_1.default, { icon: icon, color: "Primary", size: "md", theme: "light-circle-outline" })) : null,
        react_1.jsx(layout_1.Flex, { direction: "column", justifyContent: "center", gap: 4, css: { flex: 1, overflow: 'hidden' } },
            react_1.jsx(TitleText, { v6: v6 }, title),
            subtitle ? (react_1.jsx(SubTitleText, { v6: v6 }, subtitle)) : null),
        react_1.jsx(CloseButton_1.default, { css: { position: 'absolute', top: Paddings.Y, right: Paddings.X }, size: v6 ? 'sm' : 'default', onClick: onRequestClose })));
};
exports.default = DrawerHeader;
